import { render, staticRenderFns } from "./ManagerBoard.vue?vue&type=template&id=bee80166"
import script from "./ManagerBoard.vue?vue&type=script&lang=js"
export * from "./ManagerBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports